import Recordings from "./Recordings";

export default Recordings;
